// js
import React from 'react';
import PropTypes from 'prop-types';
import SecurityDetail from '../../containers/analytics/SecurityDetail';


const SecurityNonCriticalRudimentaryDetail = ({ data }) => {
  return (
    <SecurityDetail
      data={data}
      criticality='nonCritical'
      adequacy='rudimentary'
    />
  );
};

SecurityNonCriticalRudimentaryDetail.propTypes = {
  data: PropTypes.object.isRequired
};

export default SecurityNonCriticalRudimentaryDetail;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityNonCriticalRudimentaryDetail.js